"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./HorizontalBarChart.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The HorizontalBarChart component is used to show market depth information
 * in table format. Each row is interactive and will trigger callback with
 * it's price and buy/sell side.
 */
const HorizontalBarChart = /*#__PURE__*/React.forwardRef(({
  askLabel,
  askValues,
  bidLabel,
  bidValues,
  qtyLabel,
  maxAskQty,
  maxBidQty,
  collapsed = false,
  onRowClick,
  ...otherProps
}, ref) => (0, _pragma.createFelaElement)(_.View, _extends({
  flex: true,
  ref: ref
}, otherProps), (0, _pragma.createFelaElement)(_.View, {
  css: css.container,
  flex: true,
  flexDirection: "column"
}, (0, _pragma.createFelaElement)(_.View, {
  flex: true,
  alignItems: "center",
  justifyContent: "space-between",
  css: css.header,
  cssProps: {
    side: 'bid',
    collapsed
  }
}, (0, _pragma.createFelaElement)(_.Text, {
  size: "s",
  color: "text.1",
  weight: "bold",
  css: css.label,
  cssProps: {
    collapsed
  }
}, qtyLabel), (0, _pragma.createFelaElement)(_.Text, {
  size: "s",
  color: "text.1",
  weight: "bold",
  css: css.label,
  cssProps: {
    collapsed
  }
}, bidLabel)), (0, _pragma.createFelaElement)(_.View, {
  css: css.content,
  cssProps: {
    side: 'bid',
    collapsed
  },
  flex: true,
  flexDirection: "column"
}, bidValues.map((values, index) => (0, _pragma.createFelaElement)(_.View, {
  as: "button",
  flex: true,
  alignItems: "center" // eslint-disable-next-line react/no-array-index-key
  ,
  key: index,
  onClick: onRowClick && values ? () => {
    onRowClick('buy', values[1]);
  } : undefined,
  css: css.row
}, (0, _pragma.createFelaElement)(_.Text, {
  css: css.quantity,
  cssProps: {
    side: 'bid',
    collapsed
  },
  size: "s",
  color: "text.1"
}, values ? values[0] : '--'), (0, _pragma.createFelaElement)(_.View, {
  css: css.barContainer,
  justifyContent: "flex-start"
}, (0, _pragma.createFelaElement)("div", {
  css: css.bar,
  cssProps: {
    side: 'bid',
    width: values ? values[0] / maxBidQty * 100 : 0
  }
})), (0, _pragma.createFelaElement)(_.Text, {
  css: css.price,
  cssProps: {
    side: 'bid'
  },
  size: "s",
  color: "text.1"
}, values ? "\u20B9".concat(values[1]) : '--'))))), (0, _pragma.createFelaElement)(_.View, {
  css: css.container,
  flex: true,
  flexDirection: "column"
}, (0, _pragma.createFelaElement)(_.View, {
  flex: true,
  justifyContent: "space-between",
  alignItems: "center",
  css: css.header,
  cssProps: {
    side: 'ask',
    collapsed
  }
}, (0, _pragma.createFelaElement)(_.Text, {
  size: "s",
  color: "text.1",
  weight: "bold",
  css: css.label,
  cssProps: {
    collapsed
  }
}, askLabel), (0, _pragma.createFelaElement)(_.Text, {
  size: "s",
  color: "text.1",
  weight: "bold",
  css: css.label,
  cssProps: {
    collapsed
  }
}, qtyLabel)), (0, _pragma.createFelaElement)(_.View, {
  css: css.content,
  cssProps: {
    side: 'ask',
    collapsed
  },
  flex: true,
  flexDirection: "column"
}, askValues.map((values, index) => (0, _pragma.createFelaElement)(_.View, {
  as: "button",
  flex: true,
  alignItems: "center" // eslint-disable-next-line react/no-array-index-key
  ,
  key: index,
  onClick: values ? () => {
    onRowClick('sell', values[1]);
  } : undefined,
  css: css.row
}, (0, _pragma.createFelaElement)(_.Text, {
  css: css.price,
  cssProps: {
    side: 'ask'
  },
  size: "s",
  color: "text.1"
}, values ? "\u20B9".concat(values[1]) : '--'), (0, _pragma.createFelaElement)(_.View, {
  css: css.barContainer,
  justifyContent: "flex-end"
}, (0, _pragma.createFelaElement)("div", {
  css: css.bar,
  cssProps: {
    side: 'ask',
    width: values ? values[0] / maxAskQty * 100 : 0
  }
})), (0, _pragma.createFelaElement)(_.Text, {
  css: css.quantity,
  cssProps: {
    side: 'ask',
    collapsed
  },
  size: "s",
  color: "text.1"
}, values ? values[0] : '--')))))));
HorizontalBarChart.displayName = 'HorizontalBarChart';
var _default = HorizontalBarChart;
exports.default = _default;
//# sourceMappingURL=HorizontalBarChart.js.map